<script lang="ts" setup></script>

<template>
  <div class="absolute rounded-md cursor-pointer text-gray-700 w-30px h-30px bg-light-900 opacity-50 hover:text-gray-900 hover:opacity-100">
    <div class="i-carbon:fit-to-screen text-size-25px" />
  </div>
</template>
